import { Badge } from "../shared/Badge";
import { riskBadgeColor, riskLabel } from "../../lib/colormap";
import { SVI_COLORS } from "../../lib/colormap";
import { useUIStore, pushUrl } from "../../store/uiStore";
import { drawerPalette } from "../../lib/drawerTheme";
import type { SviQuintile } from "../../types/equity";

interface Props {
  cellId: string;
  pHat: number;
  sviQuintile: SviQuintile | null;
  priorityRank: number | null;
}

export function DrawerHeader({ cellId, pHat, sviQuintile, priorityRank }: Props) {
  const { selectCell } = useUIStore();
  const theme = useUIStore((s) => s.theme);
  const palette = drawerPalette(theme);

  function close() {
    selectCell(null);
    pushUrl({ selectedCellId: null });
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: "12px 16px",
        borderBottom: `1px solid ${palette.headerBorder}`,
        background: palette.headerBg,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
          <Badge label={riskLabel(pHat)} color={riskBadgeColor(pHat)} />
          {sviQuintile && (
            <Badge
              label={`SVI ${sviQuintile}`}
              color={SVI_COLORS[sviQuintile]}
              textColor={sviQuintile === "Q3" ? "#374151" : "#fff"}
            />
          )}
          {priorityRank != null && (
            <Badge label={`#${priorityRank}`} color="#6b7280" />
          )}
        </div>
        <div style={{ fontSize: 12, color: palette.cellIdText, fontFamily: "monospace" }}>
          {cellId}
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: palette.cellTitleText }}>
          Raw risk:{" "}
          <span style={{ fontVariantNumeric: "tabular-nums" }}>
            {(pHat * 100).toFixed(1)}%
          </span>
          <span style={{ fontWeight: 400, color: palette.mutedText, marginLeft: 6, fontSize: 11 }}>
            (adjusted shown below)
          </span>
        </div>
      </div>

      <button
        onClick={close}
        aria-label="Close"
        style={{
          background: "none",
          border: "none",
          fontSize: 18,
          cursor: "pointer",
          color: palette.mutedText,
          lineHeight: 1,
          padding: 2,
        }}
      >
        ×
      </button>
    </div>
  );
}
